
import {defineComponent, nextTick, onMounted, PropType, reactive, watch} from "vue";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import InputText from "primevue/inputtext";
import {LocatorSetting} from "@dex/squeeze-client-ts";
import Dropdown from "primevue/dropdown";
import {useI18n} from "vue-i18n";

export default defineComponent({
	name: 'LocatorAttributeForm',
	components: {
		InputText,
		Dropdown,
	},
	props: {
		fieldEntry: {
			type: Object as PropType<LocatorSetting>,
			default: () => ({}),
		},
		/** All Valid Settings */
		supportedLocatorSettings: {
			type: Array as PropType<LocatorSetting[]>,
			default: () => [],
		},
		showErrorMessage: {
			type: Boolean,
			default: false,
		},
		disableSetting: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		const {t} = useI18n();

		/** Current Object of all input-fields */
		const value = reactive<LocatorSetting>({locatorId: props.fieldEntry.locatorId, setting: '', value: ''});

		/** Determines the required rules for validation */
		const rules = {
			setting: { required },
			value: { required },
		}

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		onMounted(async () => {
			Object.assign(value, props.fieldEntry);

			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		});

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(() => props.fieldEntry, () => {
			Object.assign(value, props.fieldEntry);
		})

		/** Triggered on change of any field */
		const update = async () => {
			// need nextTick, because the dropdown don't check the change of a selected element (is to slow)
			await nextTick();
			emit("update", value, v$.value.$invalid);
		}

		return {
			t,
			value,
			props,
			v$,
			InputText,
			update,
		}
	},
});
